import { HtmlId } from '../enum';
import { JustText, createJustText } from '@vfde-brix/ws10/just-text';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Create Brix JustText component.
 * @param {HtmlId} id - ID of the element.
 * @returns {JustText | null} component or null if element with given id is not found
 */
export const mountJustText = (id: HtmlId) =>
    createComponentById(createJustText, id, NO_PATTERN_BUSINESS_LOGIC);

export const updateJustText = (comp: JustText | null, text?: string) => {
    comp?.update({ content: text });
    comp?.toggleContainer(!text);
};
